import React from "react";

import { Grid } from "@mui/material";
import { Skeleton } from '@mui/material';

const SkeletonAccountDetails = () => {
  const heightTitle = 30;
  const heightInput = 60;

  return (
    <Grid container item xs={12} spacing={2} direction="row">
      <Grid item xs={12}>
        <Skeleton variant="text" width="10%" height={heightTitle} />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Skeleton variant="text" width="100%" height={heightInput} />
      </Grid>
      <Grid item xs={12} sm={3}>
        <Skeleton variant="text" width="100%" height={heightInput} />
      </Grid>
    </Grid>
  );
};

export default SkeletonAccountDetails;
